// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Rock+Salt&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `header {
  display: flex;
  justify-content: center;
}

div.logo-container {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border: 3px solid black;
  width: 600px;
  padding: 7px;
  margin: 0;
  z-index: 1001;
}

.logo-signature {
  font-family: "Rock Salt", Arial, Helvetica, sans-serif;
  color: black;
}

.logo-signature-footer {
  font-family: "Rock Salt", Arial, Helvetica, sans-serif;
  color: white;
}
.nav {
  position: fixed;

  display: flex;
  flex-direction: row;
  justify-content: space-around;
  /* box-shadow: 0 0 15px 5px grey; */

  /* background-color: black; */
  z-index: 1000;
  top: 0px;
  left: 0px;
}

.nav:empty {
  height: 60px;
  /* width: 1024px; */
  background-image: linear-gradient(gray, gray), linear-gradient(white, white),
    linear-gradient(gray, gray), linear-gradient(gray, gray),
    linear-gradient(gray, gray), linear-gradient(gray, gray),
    linear-gradient(black, black);
  background-size: 200px 30px, 425px 54px, 100px 30px, 100px 30px, 100px 30px,
    100px 30px, 100% 100%;
  background-position: 130px 15px, 3px 3px, 450px, 600px, 750px, 900px, 0 0;
  background-repeat: no-repeat;
}

.short-nav {
  position: relative;
  display: flex;
  width: 100%;
  height: 60px;
}

.landing-page {
}

.nav__wrapper {
  width: 100%;
}

.nav-overlay {
  position: absolute;
  background: black;
  opacity: 0.6;
  height: 100vh;
  width: 100vw;
  visibility: hidden;
  z-index: -1;
  transition: all 0.3s ease-in-out;
}

.nav__sub-nav {
  display: flex;
  justify-content: end;

  color: white;
  background: #404040;
  box-shadow: inset 0px 3px 5px rgba(0, 0, 0, 0.5);
  margin: 0;
  padding-right: 15px;
}

.visible {
  visibility: visible;
}

div.collasped-menu-btn {
  display: none;
  justify-content: center;
  align-items: center;
  background: black;
  height: 60px;
  z-index: 1002;
}

div.scroll-top-btn {
  background: white;
  border-radius: 100%;
  height: 80px;
  width: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  opacity: 0;
  top: 500px;
  right: 20px;
  /* visibility: hidden; */
  transition: all 0.3s ease-in-out;
}

div.scroll-top-btn.active {
  opacity: 0.6;
}

div.scroll-top-btn img {
  height: 80px;
  width: 80px;
}

div.collasped-menu-btn img {
  width: 55px;
}

ul.nav-content,
ul.nav-content-landing {
  display: flex;
  flex-direction: row;
  position: relative;
  justify-content: end;

  /* FIX: width to be adjusted with various display sizes with media queiries or implement a new location implementation*/
  width: 100%;
  background: black;

  padding: 0;
  margin: 0;

  /* transition: all 0.6s ease-in-out; */
}

ul.nav-content.short-menu {
  display: flex;
  flex-direction: column;
  position: absolute;
  transform: translate(0, -300%);
  width: 100%;
  top: 60px;
  /* opacity: 1; */
}

ul.nav-content-landing.short-menu {
  display: flex;
  flex-direction: column;
  position: absolute;
  transform: translate(0, 300%);
  width: 100%;
  top: 60px;
  /* opacity: 1; */
}
/* ul.nav-content.short-menu :active {
	display: flex;
	flex-direction: column;
	position: absolute;
	transform: translate(0, 0%);
	opacity: 1;
} */

ul.nav-content.full-menu,
ul.nav-content-landing.full-menu {
  flex-direction: row;
  position: relative;
  transform: translate(0, 0%);
  padding: 0 20px 0 0;
  top: 0;
}

/* ul.nav-content.full-menu > a {
} */

ul.nav-content.landing-nav,
ul.nav-content-landing.landing-nav {
  width: 200px;
  right: 0;
  /* top: 60px;
	flex-direction: column; */
}

.link {
  /* width: 100%; */
  padding: 0 10px;
}
li.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 5px;
  width: auto;
}

li.nav-item a {
  text-decoration: none;
  color: white;
}

a.button:hover,
div.collasped-menu-btn:hover {
  background-color: #3a3a3a;
}

/* li.nav-item,
a.button {
	margin-left: 20px;
	margin-right: 20px;
} */

.nav-item {
  width: 125px;
  /* height: 60px;
	background: black; */
  display: flex;
  align-items: center;
}

/* .short-menu {
	width: 100%;
} */

.arrow {
  position: absolute;
  width: 20px;
  height: 20px;
  display: block;
  background: white;
  transform: translateY(-50%) rotate(45deg);
}

.dropdown-list {
  display: none;
  width: 125px;
  margin-top: 20px;
  padding: 0;
  text-align: center;
  transition: all 0.8s;
}

.dropdownBackground {
  width: 100px;
  height: 100px;
  position: absolute;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1),
    0 15px 35px rgba(50, 50, 93, 0.3), 0 5px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s, opacity 0.1s, transform 0.2s;
  transform-origin: 50% 0;
  display: flex;
  justify-content: center;
  opacity: 0;
}

.nav-li {
  color: white;
  list-style: none;
  margin: 5px;
}

li.dropdown-item {
  color: black;
}

li.dropdown-item a {
  font-weight: 600;
  color: black;
}

/* li.dropdown-item a:visited {
	color: gray;
	font-weight: 300;
	font-style: italic;
} */

.button {
  display: flex;
}

a {
  text-decoration: none;
}

a.button {
  background-color: black;
  width: 100%;
  height: 40px;
  text-align: center;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

a.button:empty {
  height: inherit;
  width: inherit;
  background: #ccc;
  margin: 0;
  padding: 0;
}

.landing-page-nav {
  /* justify-content: "flex-end"; */
  display: flex;
  flex-direction: column;
  position: absolute;
  transform: translate(0, 0%);
  width: 200px;
  top: 60px;
  opacity: 1;
}

.nav-content.short-menu.hide {
  opacity: 0;
  transform: translate(0, -160px);
  transition: all 0.6s ease-in-out;
}

.nav-content.short-menu.show {
  opacity: 1;
  transform: translate(0, 0px);
  transition: all 0.6s ease-in-out;
}

.nav-content-landing.short-menu.hide {
  opacity: 0;
  transform: translate(0, 160px);
  transition: all 0.6s ease-in-out;
}

.nav-content-landing.short-menu.show {
  opacity: 1;
  transform: translate(0, -160px);
  transition: all 0.6s ease-in-out;
}

@media (max-width: 1024px) {
  .nav {
    /* width: 97%; */
  }

  .main-wrapper {
    width: 100%;
  }

  ul.nav-content {
    /* display: flex;
		flex-direction: row;
		position: relative;
		justify-content: space-around;
		transform: translate(0px, 0%); */

    /* FIX: width to be adjusted with various display sizes with media queiries or implement a new location implementation*/
    /* width: 60%; */
    /* 
		padding: 0;
		margin: 0;

		opacity: 1; */
  }

  .h1 {
    width: 90%;
    align-self: center;
  }
}

@media (max-width: 768px) {
  div.collasped-menu-btn {
    /* display: flex; */
  }

  /* div.scroll-top-btn {
		display: flex;
		position: absolute;
		color: white;
		justify-content: center;
		font-size: xxx-large;
		align-items: end;
	} */

  ul.nav-content {
    /* display: none; */
    /* opacity: 0;
		transform: translate(0, -300%);
		position: absolute;

		transition: all 0.6s ease-in-out; */
    /* display: flex; */
    /* flex-direction: column;
			position: absolute;
			justify-content: space-around;

			transform: translate(0, -300%);
			position: absolute;
			opacity: 0; */
  }

  /* div.logo-container p {
		display: none;
	} */

  a.button {
    width: 100%;
  }
}

@media (max-width: 425px) {
  /* .nav {
		flex-wrap: wrap;
	} */
}
`, "",{"version":3,"sources":["webpack://./src/components/elements/navbar/nav-bar.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,aAAa;AACf;;AAEA;EACE,sDAAsD;EACtD,YAAY;AACd;;AAEA;EACE,sDAAsD;EACtD,YAAY;AACd;AACA;EACE,eAAe;;EAEf,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mCAAmC;;EAEnC,6BAA6B;EAC7B,aAAa;EACb,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB;;;iCAG+B;EAC/B;yBACuB;EACvB,yEAAyE;EACzE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;AACA;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,oBAAoB;;EAEpB,YAAY;EACZ,mBAAmB;EACnB,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,WAAW;EACX,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;;EAEpB,uHAAuH;EACvH,WAAW;EACX,iBAAiB;;EAEjB,UAAU;EACV,SAAS;;EAET,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,8BAA8B;EAC9B,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;AACA;;;;;;GAMG;;AAEH;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,MAAM;AACR;;AAEA;GACG;;AAEH;;EAEE,YAAY;EACZ,QAAQ;EACR;0BACwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;GAIG;;AAEH;EACE,YAAY;EACZ;qBACmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;GAEG;;AAEH;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;oEACkE;EAClE,kDAAkD;EAClD,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;;;;GAIG;;AAEH;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,2BAA2B;EAC3B,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE;;;;kCAI8B;;IAE9B,uHAAuH;IACvH,gBAAgB;IAChB;;;;eAIW;EACb;;EAEA;IACE,UAAU;IACV,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;;;;;;;IAOE;;EAEF;IACE,mBAAmB;IACnB;;;;qCAIiC;IACjC,mBAAmB;IACnB;;;;;;gBAMY;EACd;;EAEA;;IAEE;;EAEF;IACE,WAAW;EACb;AACF;;AAEA;EACE;;IAEE;AACJ","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Rock+Salt&display=swap\");\n\nheader {\n  display: flex;\n  justify-content: center;\n}\n\ndiv.logo-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #fff;\n  border: 3px solid black;\n  width: 600px;\n  padding: 7px;\n  margin: 0;\n  z-index: 1001;\n}\n\n.logo-signature {\n  font-family: \"Rock Salt\", Arial, Helvetica, sans-serif;\n  color: black;\n}\n\n.logo-signature-footer {\n  font-family: \"Rock Salt\", Arial, Helvetica, sans-serif;\n  color: white;\n}\n.nav {\n  position: fixed;\n\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  /* box-shadow: 0 0 15px 5px grey; */\n\n  /* background-color: black; */\n  z-index: 1000;\n  top: 0px;\n  left: 0px;\n}\n\n.nav:empty {\n  height: 60px;\n  /* width: 1024px; */\n  background-image: linear-gradient(gray, gray), linear-gradient(white, white),\n    linear-gradient(gray, gray), linear-gradient(gray, gray),\n    linear-gradient(gray, gray), linear-gradient(gray, gray),\n    linear-gradient(black, black);\n  background-size: 200px 30px, 425px 54px, 100px 30px, 100px 30px, 100px 30px,\n    100px 30px, 100% 100%;\n  background-position: 130px 15px, 3px 3px, 450px, 600px, 750px, 900px, 0 0;\n  background-repeat: no-repeat;\n}\n\n.short-nav {\n  position: relative;\n  display: flex;\n  width: 100%;\n  height: 60px;\n}\n\n.landing-page {\n}\n\n.nav__wrapper {\n  width: 100%;\n}\n\n.nav-overlay {\n  position: absolute;\n  background: black;\n  opacity: 0.6;\n  height: 100vh;\n  width: 100vw;\n  visibility: hidden;\n  z-index: -1;\n  transition: all 0.3s ease-in-out;\n}\n\n.nav__sub-nav {\n  display: flex;\n  justify-content: end;\n\n  color: white;\n  background: #404040;\n  box-shadow: inset 0px 3px 5px rgba(0, 0, 0, 0.5);\n  margin: 0;\n  padding-right: 15px;\n}\n\n.visible {\n  visibility: visible;\n}\n\ndiv.collasped-menu-btn {\n  display: none;\n  justify-content: center;\n  align-items: center;\n  background: black;\n  height: 60px;\n  z-index: 1002;\n}\n\ndiv.scroll-top-btn {\n  background: white;\n  border-radius: 100%;\n  height: 80px;\n  width: 80px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  opacity: 0;\n  top: 500px;\n  right: 20px;\n  /* visibility: hidden; */\n  transition: all 0.3s ease-in-out;\n}\n\ndiv.scroll-top-btn.active {\n  opacity: 0.6;\n}\n\ndiv.scroll-top-btn img {\n  height: 80px;\n  width: 80px;\n}\n\ndiv.collasped-menu-btn img {\n  width: 55px;\n}\n\nul.nav-content,\nul.nav-content-landing {\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  justify-content: end;\n\n  /* FIX: width to be adjusted with various display sizes with media queiries or implement a new location implementation*/\n  width: 100%;\n  background: black;\n\n  padding: 0;\n  margin: 0;\n\n  /* transition: all 0.6s ease-in-out; */\n}\n\nul.nav-content.short-menu {\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  transform: translate(0, -300%);\n  width: 100%;\n  top: 60px;\n  /* opacity: 1; */\n}\n\nul.nav-content-landing.short-menu {\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  transform: translate(0, 300%);\n  width: 100%;\n  top: 60px;\n  /* opacity: 1; */\n}\n/* ul.nav-content.short-menu :active {\n\tdisplay: flex;\n\tflex-direction: column;\n\tposition: absolute;\n\ttransform: translate(0, 0%);\n\topacity: 1;\n} */\n\nul.nav-content.full-menu,\nul.nav-content-landing.full-menu {\n  flex-direction: row;\n  position: relative;\n  transform: translate(0, 0%);\n  padding: 0 20px 0 0;\n  top: 0;\n}\n\n/* ul.nav-content.full-menu > a {\n} */\n\nul.nav-content.landing-nav,\nul.nav-content-landing.landing-nav {\n  width: 200px;\n  right: 0;\n  /* top: 60px;\n\tflex-direction: column; */\n}\n\n.link {\n  /* width: 100%; */\n  padding: 0 10px;\n}\nli.nav-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin: 5px;\n  width: auto;\n}\n\nli.nav-item a {\n  text-decoration: none;\n  color: white;\n}\n\na.button:hover,\ndiv.collasped-menu-btn:hover {\n  background-color: #3a3a3a;\n}\n\n/* li.nav-item,\na.button {\n\tmargin-left: 20px;\n\tmargin-right: 20px;\n} */\n\n.nav-item {\n  width: 125px;\n  /* height: 60px;\n\tbackground: black; */\n  display: flex;\n  align-items: center;\n}\n\n/* .short-menu {\n\twidth: 100%;\n} */\n\n.arrow {\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  display: block;\n  background: white;\n  transform: translateY(-50%) rotate(45deg);\n}\n\n.dropdown-list {\n  display: none;\n  width: 125px;\n  margin-top: 20px;\n  padding: 0;\n  text-align: center;\n  transition: all 0.8s;\n}\n\n.dropdownBackground {\n  width: 100px;\n  height: 100px;\n  position: absolute;\n  background: #fff;\n  border-radius: 4px;\n  box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1),\n    0 15px 35px rgba(50, 50, 93, 0.3), 0 5px 15px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s, opacity 0.1s, transform 0.2s;\n  transform-origin: 50% 0;\n  display: flex;\n  justify-content: center;\n  opacity: 0;\n}\n\n.nav-li {\n  color: white;\n  list-style: none;\n  margin: 5px;\n}\n\nli.dropdown-item {\n  color: black;\n}\n\nli.dropdown-item a {\n  font-weight: 600;\n  color: black;\n}\n\n/* li.dropdown-item a:visited {\n\tcolor: gray;\n\tfont-weight: 300;\n\tfont-style: italic;\n} */\n\n.button {\n  display: flex;\n}\n\na {\n  text-decoration: none;\n}\n\na.button {\n  background-color: black;\n  width: 100%;\n  height: 40px;\n  text-align: center;\n  padding: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\na.button:empty {\n  height: inherit;\n  width: inherit;\n  background: #ccc;\n  margin: 0;\n  padding: 0;\n}\n\n.landing-page-nav {\n  /* justify-content: \"flex-end\"; */\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  transform: translate(0, 0%);\n  width: 200px;\n  top: 60px;\n  opacity: 1;\n}\n\n.nav-content.short-menu.hide {\n  opacity: 0;\n  transform: translate(0, -160px);\n  transition: all 0.6s ease-in-out;\n}\n\n.nav-content.short-menu.show {\n  opacity: 1;\n  transform: translate(0, 0px);\n  transition: all 0.6s ease-in-out;\n}\n\n.nav-content-landing.short-menu.hide {\n  opacity: 0;\n  transform: translate(0, 160px);\n  transition: all 0.6s ease-in-out;\n}\n\n.nav-content-landing.short-menu.show {\n  opacity: 1;\n  transform: translate(0, -160px);\n  transition: all 0.6s ease-in-out;\n}\n\n@media (max-width: 1024px) {\n  .nav {\n    /* width: 97%; */\n  }\n\n  .main-wrapper {\n    width: 100%;\n  }\n\n  ul.nav-content {\n    /* display: flex;\n\t\tflex-direction: row;\n\t\tposition: relative;\n\t\tjustify-content: space-around;\n\t\ttransform: translate(0px, 0%); */\n\n    /* FIX: width to be adjusted with various display sizes with media queiries or implement a new location implementation*/\n    /* width: 60%; */\n    /* \n\t\tpadding: 0;\n\t\tmargin: 0;\n\n\t\topacity: 1; */\n  }\n\n  .h1 {\n    width: 90%;\n    align-self: center;\n  }\n}\n\n@media (max-width: 768px) {\n  div.collasped-menu-btn {\n    /* display: flex; */\n  }\n\n  /* div.scroll-top-btn {\n\t\tdisplay: flex;\n\t\tposition: absolute;\n\t\tcolor: white;\n\t\tjustify-content: center;\n\t\tfont-size: xxx-large;\n\t\talign-items: end;\n\t} */\n\n  ul.nav-content {\n    /* display: none; */\n    /* opacity: 0;\n\t\ttransform: translate(0, -300%);\n\t\tposition: absolute;\n\n\t\ttransition: all 0.6s ease-in-out; */\n    /* display: flex; */\n    /* flex-direction: column;\n\t\t\tposition: absolute;\n\t\t\tjustify-content: space-around;\n\n\t\t\ttransform: translate(0, -300%);\n\t\t\tposition: absolute;\n\t\t\topacity: 0; */\n  }\n\n  /* div.logo-container p {\n\t\tdisplay: none;\n\t} */\n\n  a.button {\n    width: 100%;\n  }\n}\n\n@media (max-width: 425px) {\n  /* .nav {\n\t\tflex-wrap: wrap;\n\t} */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
